import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionMeta } from 'react-select';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { ISelectOption } from 'types/components/inputs/input.interface';
import { flattenTree } from 'utils/dnd/dndUtilities';
import { IContractInputBaseProps } from '../../base/ContractInputBase';
import './ContractInputAgreementSelect.scss';

interface IContractInputAgreementSelectProps
  extends Omit<IContractInputBaseProps, 'name'> {
  id: string;
  onCreateOption?: (inputValue: string) => void;
  onSelectChange?: (newValue: any, actionMeta: ActionMeta<any>) => void;
}

const ContractInputAgreementSelect = ({
  id,
  onCreateOption,
  onSelectChange,
  ...props
}: IContractInputAgreementSelectProps) => {
  const {
    setItemAndDetailValue,
    itemNameById,
    values,
    displayMode,
    setFieldValue,
  } = useFormikContractHelpers();

  const { t } = useTranslation();

  const getSelectOptions = () => {
    const item = flattenTree(values.items).find(item => item.id === id);

    return item?.type === TEMPLATE_TYPE.agreement
      ? (item.content.selectAgreementTemplate?.options ?? [])
          .filter(option => option.trim().length)
          .map((option, key) => ({
            label: option,
            value: key + 1,
          }))
      : [];
  };

  const selectDefaultValue = (option: ISelectOption<string | number>) => {
    console.log(option.label);
    setItemAndDetailValue<string>(
      'content.selectAgreementTemplate.defaultValue',
      option.label
    );
    setFieldValue(
      `${itemNameById(id)}.content.selectAgreementTemplate.defaultValue`,
      option.label
    );
  };

  useEffect(() => {
    console.log(values.items[0].children[0].children[0].content);
  }, [values.items[0].children[0].children[0].content]);

  return (
    <Contract.Input.Base
      {...props}
      id={id}
      classNames={[
        'contract-input-agreement',
        'contract-input-agreement-select',
      ]}
      placeholder={t('input.label.title')}
      name={`${itemNameById(id)}.content.selectAgreementTemplate.title`}>
      <FormInput.Select
        name={`${itemNameById(
          id
        )}.content.selectAgreementTemplate.defaultValue`}
        className='contract-input-agreement-select'
        placeholder={t('input.label.default-option')}
        onChange={selectDefaultValue}
        options={getSelectOptions()}
        displayMode={displayMode}
      />
    </Contract.Input.Base>
  );
};

export default ContractInputAgreementSelect;
